import {calculateInfluencePathIncome} from "../calculateInfluencePathIncome";
import {TEMPLE_BASIC_INCOME} from "../../../configs/income";
import {FACTIONS} from "../../../constants/factions";
import {FACTION_VENTORY_ADDITIONAL_TEMPLE_INCOME} from "../../../configs/factions/ventory";
import {isPlayerFaction} from "../../factions/isPlayerFaction";
import {isPlayerPolicy} from "../../factions/isPlayerPolicy";
import {POLICIES} from "../../../constants/policies";
import {POLICY_HEGEMONISM_TEMPLE_WIN_POINTS_INCOME_BONUS} from "../../../configs/policy/hegemonism";
import {isHegemonismBonusHexKey} from "../../policy/hegemonism/isHegemonismBonusHexKey";
import {POLICY_THEOCRACY_TEMPLE_WIN_POINTS_INCOME_BONUS} from "../../../configs/policy/theocracy";

/**
 * Доход храма (очки) по слагаемым — для расшифровки дохода игрока (панель
 * статов в шапке); calcTempleIncome — их сумма
 * @returns {{base: number, influence: number, ventory: number, hegemonism: number, theocracy: number, total: number}}
 */
export const calcTempleIncomeDetails = (templeHexKey, player, enemyCities, hexes) => {
  const {count} = calculateInfluencePathIncome(templeHexKey, enemyCities, hexes);

  const ventory = isPlayerFaction(player, FACTIONS.VENTORY) ? FACTION_VENTORY_ADDITIONAL_TEMPLE_INCOME : 0;
  const hegemonism = isPlayerPolicy(player, POLICIES.HEGEMONISM) && isHegemonismBonusHexKey(templeHexKey)
    ? POLICY_HEGEMONISM_TEMPLE_WIN_POINTS_INCOME_BONUS
    : 0;
  const theocracy = isPlayerPolicy(player, POLICIES.THEOCRACY) ? POLICY_THEOCRACY_TEMPLE_WIN_POINTS_INCOME_BONUS : 0;

  return {
    base: TEMPLE_BASIC_INCOME,
    influence: count,
    ventory,
    hegemonism,
    theocracy,
    total: TEMPLE_BASIC_INCOME + count + ventory + hegemonism + theocracy,
  };
};

export const calcTempleIncome = (templeHexKey, player, enemyCities, hexes) => (
  calcTempleIncomeDetails(templeHexKey, player, enemyCities, hexes).total
);
